import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

// Styling
export const StyledButton = styled(Button, {})({
  ...theme.typography.button,

  opacity: 1,
  padding: '23px 29px 20px',

  gap: 0,

  borderRadius: '50px',
  background: `linear-gradient(90deg, ${theme.palette.newPrimary} 0%, ${theme.palette.newSecondary} 100%)`,

  boxShadow: `0 2px ${theme.palette.lightgrey}`,

  color: theme.palette.black,

  transition: 'opacity 250ms ease-in-out, padding 100ms ease-in-out, gap 100ms ease-in-out',

  '&:hover': {
    opacity: 0.8,
    padding: '23px 18px 20px 29px',

    gap: 11,

    background: theme.palette.newPrimary,

    transition: 'opacity 250ms ease-in-out, padding 100ms ease-in-out, gap 100ms ease-in-out',
  },
});
